import useWindowSize from '@components/_hooks/useWindowSize'
import { count, getCanonicalSlug, productLink } from '@components/config/helpers'
import StyledBox from '@components/Custom/Box/StyledBox'
import Image from 'next/image'
import Link from 'next/link'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';

export default function CategoryProductExtras({ product, source = 'category' }) {
    const { width, isMobile } = useWindowSize();
    const MAX = useMemo(() => {
        if (!isMobile) {
            if (width > 2100) return 6;
            else if (width > 1800) return 4;
            else if (width > 1000) return 3;
        }
        else if (isMobile) {
            if (width > 1050) return 4;
            else if (width > 1000) return 3;
            else if (width > 750) return 4;
            else if (width < 400) return 2;
        };
    }, [isMobile, width])

    const cat_slug = useSelector((state) => state.categoryReducer?.categoryState?.category?.slug);
    const totalRemaining = count(product.product_extras) > MAX ? (count(product.product_extras) - MAX) : null;
    const link = getCanonicalSlug({ canonical_category_slug: cat_slug ? cat_slug : product.canonical_category_slug });

    return (

        <>
            {product.product_extras.map((extra, idx) => {


                if ((idx + 1) > MAX) {
                    return;
                }
                const append = `?extra=${extra.extra_slug}&group=${extra.extra_group}`;
                const urlLink = getCanonicalSlug({ canonical_category_slug: cat_slug ? cat_slug : product.canonical_category_slug });

                return (
                    <Grid
                        key={extra.extra_slug}
                        container
                        direction={'row'}
                        className={`${source == 'search' ? 'd-none' : 'd-block'} hover-underline w-fit`}
                    >
                        <Grid
                            item xs={12}
                            // className={`mr-1 ${!product || (product && product?.product_id !== variant.product_variant_product_id) && 'hover-underline'}`}
                            sx={{
                                // border: (!product) || (product && product?.product_id === variant.product_variant_product_id) ? '2px solid var(--color-primary)' : 'unset'
                            }}
                        >
                            <Link shallow={true} className={`mr-1 d-flex`} href={productLink(urlLink, product.product_slug, product.long_term) + append}>
                                <Image
                                    loading="lazy"
                                    priority={false}
                                    width={50}
                                    height={50}
                                    src={extra.image}
                                    alt={extra.extra_name}
                                    title={extra.extra_name}
                                    quality={75}
                                />
                            </Link>
                        </Grid>
                    </Grid>
                )
            })}

            {totalRemaining > 0 && <Box className={`p-0 ml-1 vertical-auto`} sx={{ display: 'end', flexDirection: 'row', fontSize: 14, color: 'primary.main', }}>
                <Link
                    href={productLink(link, product.product_slug, product.long_term)}>
                    <StyledBox className='quote-increment'
                        // sx={{padding: { md: '2px', lg: '5px' }}}  //original value
                        sx={{ padding: { md: '5px', lg: '5px' } }} // adjustment due to box padding
                    >
                        +{totalRemaining}
                    </StyledBox>
                </Link>
            </Box>}
        </>

    )
}
